var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVentCerradaD(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 93,
    height: 193,
    viewBox: "0 0 93 193",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M88.26 51.46L13.06 7.76L0.619995 0.529999V14.92V134.38V139.14L4.74 141.54L79.94 185.24L92.38 192.47V178.08V58.62V53.86L88.26 51.46Z",
    fill: "#B8B8B9",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M84.1 58.62L8.89999 14.92V134.38L84.1 178.08V58.62Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M84.1 166.07L18.87 128.16V20.71L8.89999 14.92V122.37V134.38L18.87 140.17L84.1 178.08V166.07Z",
    fill: "#DDDDDF",
    stroke: "#666666",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.87 128.16V20.71L8.89999 14.92V122.37V134.38L18.87 128.16Z",
    fill: "#A6A6A7",
    stroke: "#666666",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M71.83 107.81V113.1C71.8227 113.483 71.9181 113.862 72.1063 114.196C72.2944 114.53 72.5684 114.808 72.9 115L74.35 115.84C74.5278 115.943 74.7293 115.997 74.9346 115.998C75.1399 115.999 75.3419 115.947 75.5206 115.846C75.6994 115.745 75.8487 115.599 75.9538 115.422C76.0589 115.246 76.1162 115.045 76.12 114.84V110C76.1095 109.593 75.9945 109.195 75.7861 108.845C75.5778 108.494 75.283 108.204 74.93 108L73.26 107C73.1145 106.93 72.9542 106.896 72.7927 106.901C72.6313 106.907 72.4736 106.951 72.333 107.031C72.1925 107.11 72.0733 107.223 71.9857 107.359C71.8981 107.494 71.8447 107.649 71.83 107.81Z",
    fill: "#B8B8B9",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M71.62 107.8C70.4 113.41 70.69 121.47 71.62 127.12C71.7002 127.527 71.8751 127.909 72.1304 128.236C72.3858 128.562 72.7146 128.824 73.09 129C73.63 129.28 74.17 129.56 74.72 129.83C75.61 130.28 76.45 129.73 76.26 128.83C75.11 123.39 74.58 115.5 75.48 110.03C75.5525 109.656 75.5166 109.269 75.3767 108.915C75.2367 108.56 74.9985 108.254 74.69 108.03L73.23 107.03C73.0755 106.957 72.9066 106.919 72.7357 106.919C72.5647 106.92 72.396 106.958 72.2418 107.032C72.0876 107.106 71.9518 107.213 71.8442 107.346C71.7366 107.479 71.6601 107.634 71.62 107.8Z",
    fill: "#B8B8B9",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M84.1 58.62L8.89999 14.92V134.38L84.1 178.08V58.62Z",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVentCerradaD);
export default __webpack_public_path__ + "static/media/VentCerradaD.d59c065c284d40e3a1fb12d27f12cf50.svg";
export { ForwardRef as ReactComponent };